import React from "react";
import classNames from "classnames";

type SpinnerProps = {
    tag?: React.ElementType;
    className?: string;
    size?: "lg" | "md" | "sm";
    type?: "bordered" | "grow";
    color?: string;
    children?: React.ReactNode;
};

export default function Spinner({ tag = "div", type = "bordered", className, color, size, children }: SpinnerProps) {
    return (
        <div
            role="status"
            className={classNames(
                {
                    "spinner-border": type === "bordered",
                    "spinner-grow": type === "grow",
                },
                color ? `text-${color}` : `text-secondary`,
                { [`avatar-${size}`]: size },
                className
            )}
        >
            {children}
        </div>
    );
};